import { render, staticRenderFns } from "./FeaturedImageSlider.vue?vue&type=template&id=34d27e87"
import script from "./FeaturedImageSlider.vue?vue&type=script&lang=js"
export * from "./FeaturedImageSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports